import { 
  loginAdmin as loginModel, 
  logoutAdmin as logoutModel,
  getCurrentAdmin,
  isAdminAuthenticated
} from '../models/authModel';
import { logActivity } from './adminStatsController';

export const login = async (email, password, setError, navigate) => {
  try {
    const result = await loginModel(email, password);
    
    if (result.success) {
      // Log successful admin login activity
      try {
        await logActivity({
          action: 'Admin login',
          user: email,
          type: 'system'
        });
      } catch (logError) {
        console.warn('Failed to log admin login activity:', logError);
        // Don't fail the login if activity logging fails
      }
      
      navigate('/admin/dashboard');
      return true;
    } else {
      setError(result.error || 'Failed to login');
      return false;
    }
  } catch (error) {
    setError(error.message || 'An unexpected error occurred');
    return false;
  }
};

export const logout = async (navigate) => {
  try {
    const result = await logoutModel();
    
    if (result.success) {
      navigate('/admin');
      return true;
    }
    return false;
  } catch (error) {
    console.error('Logout error:', error);
    return false;
  }
};

export const checkAuthStatus = async (navigate, isProtectedRoute = true) => {
  try {
    const isAuthenticated = await isAdminAuthenticated();
    
    if (isProtectedRoute && !isAuthenticated) {
      // If on a protected route but not authenticated, redirect to login
      navigate('/admin');
      return false;
    } else if (!isProtectedRoute && isAuthenticated) {
      // If on login page but already authenticated, redirect to dashboard
      navigate('/admin/dashboard');
      return true;
    }
    
    return isAuthenticated;
  } catch (error) {
    console.error('Auth check error:', error);
    if (isProtectedRoute) {
      navigate('/admin');
    }
    return false;
  }
};

export const getAdminUser = async () => {
  try {
    return await getCurrentAdmin();
  } catch (error) {
    console.error('Get admin error:', error);
    return null;
  }
}; 